"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var zod_1 = require("zod");
var common_1 = require("./common");
var RegionalFilteredProductTabGridItemSchema = zod_1.z.object({
    action: common_1.CommonResponseItemActionDto,
    badges: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
    benefits: zod_1.z.array(common_1.CommonResponseItemBenefitDto),
    captions: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
    /** 커스텀 로그 데이터 전달을 위한 필드 */
    logMeta: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).nullish(),
    descriptions: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
    /** 고유번호 */
    id: zod_1.z.string(),
    /** 이미지 정보 */
    image: common_1.CommonResponseItemImageDto,
    /** 썸네일 안의 장소 영역 */
    locationDescription: common_1.CommonResponseItemPropertyDto.nullish(),
    locations: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
    prices: zod_1.z.array(zod_1.z.array(common_1.CommonResponseItemPropertyDto)),
    /** 썸네일 안의 순위 영역 */
    rankingDescription: common_1.CommonResponseItemPropertyDto.nullish(),
    review: common_1.CommonResponseItemPropertyDto.nullish(),
    titles: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
});
var RegionalFilteredProductTabGridWidgetDataSchema = zod_1.z.object({
    header: zod_1.z
        .object({
        icon: zod_1.z.string().optional(),
        subTitle: zod_1.z.string().optional(),
        title: zod_1.z.string(),
        more: common_1.WidgetMoreSchema.optional(),
    })
        .nullish(),
    items: zod_1.z.array(zod_1.z.object({
        action: common_1.CommonResponseItemActionDto,
        id: zod_1.z.string(),
        items: zod_1.z.array(RegionalFilteredProductTabGridItemSchema),
        title: zod_1.z.string(),
        logMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
    })),
    logMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
